<template>
  <div>
    <img-dialog-header
      header-txt="Trainingen"
      :image-url="page.active_image ? page.active_image.url : ''"
    >
      <div class="prose content" v-html="page.template.introductie"/>
    </img-dialog-header>

    <wave-content>
      <div class="prose content" v-html="page.template.tekst"/>
    </wave-content>

    <activities
      v-if="!$apollo.loading"
      header-txt="Trainingen"
      :items="activiteiten"
    />
  </div>
</template>

<script>
import ImgDialogHeader from '~/components/headers/ImgDialogHeader';
import WaveContent from '~/components/fullwidth-blocks/WaveContent';
import Activities from '~/components/fullwidth-blocks/Activities';
import page from '~/plugins/mixins/page';
import activiteiten from '~/graphql/queries/activiteiten';

export default {
  components: {Activities, WaveContent, ImgDialogHeader},
  mixins: [page],
  apollo: {
    activiteiten: {
      query: activiteiten,
      variables() {
        return {
          category: 'trainingen',
        };
      },
    },
  },
};
</script>
